import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "nav-item"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
    key: 1,
    class: "nav-item dropdown"
};
const _hoisted_4 = ["id"];
const _hoisted_5 = ["aria-labelledby"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (!_ctx.menuItem.children || _ctx.menuItem.children.length === 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
            (_ctx.menuItem.actionCommand)
                ? (_openBlock(), _createBlock(_component_g_link, {
                    key: 0,
                    src: _ctx.menuItem.actionCommand,
                    target: _ctx.menuItem.actionTarget,
                    class: "nav-link"
                }, {
                    default: _withCtx(() => [
                        (_ctx.menuItem.iconUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.menuItem.iconUrl
                            }, null, 8, _hoisted_2))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.getMenuItemCaption(_ctx.menuItem)), 1)
                    ]),
                    _: 1
                }, 8, ["src", "target"]))
                : _createCommentVNode("", true)
        ]))
        : (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createElementVNode("a", {
                class: "nav-link dropdown-toggle",
                href: "#",
                id: 'navbarDropdown_' + _ctx.menuItem.menuID,
                role: "button",
                "data-bs-toggle": "dropdown",
                "aria-expanded": "false"
            }, _toDisplayString(_ctx.getMenuItemCaption(_ctx.menuItem)), 9, _hoisted_4),
            _createElementVNode("ul", {
                class: _normalizeClass(['dropdown-menu', _ctx.align === 'right' ? 'dropdown-menu-end text-end' : '']),
                "aria-labelledby": 'navbarDropdown_' + _ctx.menuItem.menuID
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItem.children, (subMenuItem) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (subMenuItem.beginGroup)
                            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [...(_cache[0] || (_cache[0] = [
                                    _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
                                ]))]))
                            : _createCommentVNode("", true),
                        _createElementVNode("li", null, [
                            _createVNode(_component_g_link, {
                                src: subMenuItem.actionCommand,
                                target: subMenuItem.actionTarget,
                                class: "dropdown-item",
                                "default-class": ""
                            }, {
                                default: _withCtx(() => [
                                    (subMenuItem.iconUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: subMenuItem.iconUrl
                                        }, null, 8, _hoisted_7))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.getMenuItemCaption(subMenuItem)), 1)
                                ]),
                                _: 2
                            }, 1032, ["src", "target"])
                        ])
                    ], 64));
                }), 256))
            ], 10, _hoisted_5)
        ]));
}
